import React, {Component} from 'react';
import Select from 'react-select';
import DataChartComponent from './DataChartComponent';

const types = [
    {value: 'by_year', label: window.__js_dashboard.by_year},
    {value: 'by_department', label: window.__js_dashboard.by_department},
];

export default class ContractCreationTime extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: types[0],
        };

        this.onTypeChange = this.onTypeChange.bind(this);
    }

    onTypeChange(value) {
        this.setState({type: value});
    }

    render() {
        const type = this.state.type
            ? this.state.type.value
            : null;

        let data = [];

        switch (type) {
            case 'by_year':
                data = this.props.byYear;
                break;
            case 'by_department':
                data = this.props.byDepartment;
                break;
        }

        return (
            <div className="x_panel">
                <div className="x_title">
                    <h2>
                        <i className="fa fa-angle-right"></i> {window.__js_dashboard.contract_creation_time}
                    </h2>
                    <div className="clearfix"></div>
                </div>
                <div className="x_content">
                    <div className="row">
                        <div className="col-md-6">
                            <Select value={this.state.type}
                                    options={types}
                                    clearable={false}
                                    placeholder={window.__js_general.choose_literal}
                                    onChange={this.onTypeChange}>
                            </Select>
                        </div>
                        <div className="col-md-6"></div>
                    </div>

                    <br/>

                    <div className="row">
                        <div className="col-md-12">
                            <DataChartComponent data={data}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}